<template>
    <div>
        <div class="d-flex justify-space-around flex-wrap">

            <div class="general-field-small" v-if="value.hwInfo.system">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-laptop</v-icon>
                    System
                </div>
                <div class="pl-2 text-caption">
                    <div>Manufacturer: {{value.hwInfo.system.manufacturer || '-'}}</div>
                    <div>Model: {{value.hwInfo.system.model || '-'}}</div>
                    <div>Serial: {{value.hwInfo.system.serial || '-'}}</div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.systemInformation">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-laptop</v-icon>
                    System
                </div>
                <div class="pl-2 text-caption">
                    <div>Manufacturer: {{value.hwInfo.systemInformation.Manufacturer}}</div>
                    <div>Model: {{value.hwInfo.systemInformation.Model}}</div>
                    <div>Domain: {{value.hwInfo.systemInformation.Domain}}</div>
                    <div>Workgroup: {{value.hwInfo.systemInformation.Workgroup}}</div>
                    <div>DNS HostName: {{value.hwInfo.systemInformation.DNSHostName}}</div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.mem">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-microsoft</v-icon>
                    Operating System
                </div>
                <div class="pl-2 text-caption">
                    <div>Hostname: {{value.hwInfo.osInfo.hostname}}</div>
                    <div>Username: {{value.hwInfo.username}}</div>
                    <div>Distro: {{value.hwInfo.osInfo.distro}}</div>
                    <div>Architecture: {{value.hwInfo.osInfo.arch}}</div>
                    <div>Build: {{value.hwInfo.osInfo.build}}</div>
                    <div>Hypervisor: {{value.hwInfo.osInfo.hypervisor ? 'Yes' : 'No'}}</div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.operatingSystemInformation">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-microsoft</v-icon>
                    Operating System
                </div>
                <div class="pl-2 text-caption">
                    <div>UserName: {{value.hwInfo.operatingSystemInformation.UserName}}</div>
                    <div>Name: {{value.hwInfo.operatingSystemInformation.Name}}</div>
                    <div>Distro: {{value.hwInfo.operatingSystemInformation.Distro}}</div>
                    <div>Architecture: {{value.hwInfo.operatingSystemInformation.Architecture}}</div>
                    <div>Build: {{value.hwInfo.operatingSystemInformation.Build}}</div>
                    <div>Hypervisor: {{value.hwInfo.operatingSystemInformation.Hypervisor}}</div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.cpu">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-memory</v-icon>
                    CPU
                </div>
                <div class="pl-2 text-caption">
                    <div>Manufacturer: {{ value.hwInfo.cpu.manufacturer || '-' }}</div>
                    <div>Processors: {{ value.hwInfo.cpu.processors || '-' }}</div>
                    <div>Physical Cores: {{ value.hwInfo.cpu.physicalCores || '-' }}</div>
                    <div>Cores: {{ value.hwInfo.cpu.cores || '-' }}</div>
                    <div>Brand: {{ value.hwInfo.cpu.brand || '-' }}</div>
                    <div>Speed: {{ value.hwInfo.cpu.speed ? `${value.hwInfo.cpu.speed} Ghz` : '-' }}</div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.cpuInformation">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-memory</v-icon>
                    CPU
                </div>
                <div class="pl-2 text-caption">
                    <div>Manufacturer: {{value.hwInfo.cpuInformation.Manufacturer}}</div>
                    <div>Processors: {{value.hwInfo.cpuInformation.Processors}}</div>
                    <div>PhysicalCores: {{value.hwInfo.cpuInformation.PhysicalCores}}</div>
                    <div>Cores: {{value.hwInfo.cpuInformation.Cores}}</div>
                    <div>Brand: {{value.hwInfo.cpuInformation.Brand}}</div>
                    <div>Speed: {{value.hwInfo.cpuInformation.Speed}}</div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.mem">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-chip</v-icon>
                    Memory
                </div>
                <div class="pl-2 text-caption">
                    <div>Total: {{value.hwInfo.mem.total ? `${(value.hwInfo.mem.total / 1024 / 1024 / 1024).toFixed(1)} GB` : '-'}}</div>
                    <div>Used: {{value.hwInfo.mem.used ? `${(value.hwInfo.mem.used / 1024 / 1024 / 1024).toFixed(1)} GB` : '-'}}</div>
                    <div>Free: {{value.hwInfo.mem.free ? `${(value.hwInfo.mem.free / 1024 / 1024 / 1024).toFixed(1)} GB` : '-'}}</div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.memoryInformation">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-chip</v-icon>
                    Memory
                </div>
                <div class="pl-2 text-caption">
                    <div>Total: {{(value.hwInfo.memoryInformation.Total || 0).toFixed(1)}} GB</div>
                    <div>Used: {{(value.hwInfo.memoryInformation.Used || 0).toFixed(1)}} GB</div>
                    <div>Free: {{(value.hwInfo.memoryInformation.Free || 0).toFixed(1)}} GB</div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.diskLayout && value.hwInfo.diskLayout.length">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-harddisk</v-icon>
                    Disk Layout
                </div>
                <div class="pl-2 text-caption">
                    <div v-for="disk in value.hwInfo.diskLayout">
                        <div class="font-weight-bold">
                            {{disk.name}}
                        </div>
                        <div class="pl-4">
                            <div>Type: {{disk.type || '-'}}</div>
                            <div>Smart Status: {{disk.smartStatus || '-'}}</div>
                            <div>Size: {{disk.size ? `${(disk.size / 1024 / 1024 / 1024).toFixed(1)} GB` : '-'}}</div>
                            <div>Serial No: {{disk.serialNum || '-'}}</div>
                            <div>Interface: {{disk.interfaceType || '-'}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.diskInformation && value.hwInfo.diskInformation.length">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-harddisk</v-icon>
                    Disk Layout
                </div>
                <div class="pl-2 text-caption">
                    <div v-for="disk in value.hwInfo.diskInformation">
                        <div class="font-weight-bold">
                            {{disk.Model}}:
                        </div>
                        <div class="pl-4">
                            <div>Type: {{disk.Type}}</div>
                            <div>Size: {{disk.Size}}</div>
                            <div>SerialNo: {{disk.SerialNo}}</div>
                            <div>Interface: {{disk.Interface}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.fsSize && value.hwInfo.fsSize.length">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-chart-donut</v-icon>
                    File System Layout
                </div>
                <div class="pl-2 text-caption">
                    <div v-for="fs in value.hwInfo.fsSize">
                        <div class="font-weight-bold">
                            {{fs.fs}}
                        </div>
                        <div class="pl-4">
                            <div>Type: {{fs.type || '-'}}</div>
                            <div>Size: {{fs.size ? `${(fs.size / 1024 / 1024 / 1024).toFixed(1)} GB` : '-'}}</div>
                            <div>Used: {{fs.used ? `${(fs.used / 1024 / 1024 / 1024).toFixed(1)} GB` : '-'}}</div>
                            <div>Available: {{fs.available ? `${(fs.available / 1024 / 1024 / 1024).toFixed(1)} GB` : '-'}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="general-field-small" v-if="value.hwInfo.fileSystemInformation && value.hwInfo.fileSystemInformation.length">
                <div class="text-body-1 pb-1 white--text">
                    <v-icon left>mdi-chart-donut</v-icon>
                    File System Layout
                </div>
                <div class="pl-2 text-caption">
                    <div v-for="fs in value.hwInfo.fileSystemInformation">
                        <div class="font-weight-bold">
                            {{fs.DriveLetter}}
                        </div>
                        <div class="pl-4">
                            <div>File System: {{fs.FsType}}</div>
                            <div>Total Size: {{(fs.TotalSizeGB || 0).toFixed(1)}} GB</div>
                            <div>Free Space: {{(fs.FreeSpaceGB || 0).toFixed(1)}} GB</div>
                            <div>Used Space: {{(fs.UsedSpaceGB || 0).toFixed(1)}} GB</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="value.hwInfo.lastUpdate" class="text-end grey--text caption pb-1">Last Update: {{format(new Date(value.hwInfo.lastUpdate), "yyyy-MM-dd HH:mm:ss")}}</div>
    </div>
</template>

<script>
import {Device} from "@/models/device";
import {format} from "date-fns";

export default {
    props: {
        device: Object
    },
    data() {
        return {
            value: new Device(),
            droppedKeys: [],
            format: format,
        }
    },
    watch: {
        device: {
            immediate: true,
            handler(val) {
                if (!!val && !(this.device instanceof Device))
                    this.value = new Device(JSON.parse(JSON.stringify(this.device)))
                else
                    this.value = this.device
            }
        }
    },
    computed: {
        hwInfoKeys() {
            if (this.device.hwInfo) {

                return Object.keys(this.device.hwInfo).map(key => {
                    return {
                        description: key.split(/(?=[A-Z])/g).map(word => {
                            const letters = word.split('')
                            letters[0] = letters[0].toUpperCase()
                            return letters.join('')
                        }).join(' '),
                        value: key
                    }
                })
            } else return null
        }
    }
}
</script>

<style scoped>

</style>